import React from 'react';
import { TableCellType } from '../ComparisonTableTypes';
import styles from './TableDesktop.module.scss';
import { TableDesktopCell } from './TableDesktopCell/TableDesktopCell';

export interface TableDesktopProps {
  data: TableCellType[][];
}

export const TableDesktop: React.FC<TableDesktopProps> = ({ data }) => {
  if (!data || data.length < 2) {
    return null;
  }

  const headerRow = data[0];
  const bodyRows = data.slice(1);

  return (
    <table className={styles.table}>
      <thead>
        <tr>
          {headerRow.map((cell, colIdx) => (
            <th key={`header-${colIdx}`}>
              <TableDesktopCell {...cell} isHeader />
            </th>
          ))}
        </tr>
      </thead>
      <tbody>
        {bodyRows.map((row, rowIdx) => (
          <tr key={`row-${rowIdx}`}>
            {row.map((cell, colIdx) => (
              <td key={`cell-${rowIdx}-${colIdx}`}>
                <TableDesktopCell {...cell} isRowHeader={colIdx == 0} />
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};
